import { Resources } from 'constants/resources';

import { AxiosResponse, AxiosError } from 'axios';
import { axios } from 'config/axios';
import qs from 'qs';
import { ProviderAccount } from 'types/embedded/providerAccount';
import { getId } from 'utils';

export const updateProviderAccountWorkTeam = async (
  id: string,
  workTeam?: string,
): Promise<ProviderAccount> =>
  axios
    .patch(
      `${Resources.ProviderAccounts}/${getId(id)}/work_team`,
      { workTeam },
      {
        headers: {
          'content-type': 'application/merge-patch+json',
        },
      },
    )
    .then((response: AxiosResponse) => response.data)
    .catch((error: AxiosError) => Promise.reject(error.response));

export const updateProviderAccountWorkTeamUsers = async (
  id: string,
  form: { workTeam?: string; members?: string[] },
): Promise<ProviderAccount> =>
  axios
    .patch(`${Resources.ProviderAccounts}/${getId(id)}/members`, form, {
      headers: {
        'content-type': 'application/merge-patch+json',
      },
    })
    .then((response: AxiosResponse) => response.data)
    .catch((error: AxiosError) => Promise.reject(error.response));

export const bulkAddProviderAccountsMembers = async (form: {
  providerAccounts: string[];
  members: string[];
}): Promise<ProviderAccount[]> =>
  axios
    .patch(`${Resources.ProviderAccounts}/bulk/add_members`, form, {
      headers: {
        'content-type': 'application/merge-patch+json',
      },
    })
    .then((response: AxiosResponse) => response.data)
    .catch((error: AxiosError) => Promise.reject(error.response));

export type AvailableProvider = {
  id: number;
  name: string;
};

export const getAvailableProviders = async (
  company: string,
  merchants: string[],
): Promise<AvailableProvider[]> => {
  const params = qs.stringify({ company: [company], merchant: merchants });

  return axios
    .get(`${Resources.Providers}/available/provider-account?${params}`, {
      headers: { Accept: '*/*' },
    })
    .then((response: AxiosResponse) => response.data['hydra:member'])
    .catch((error: AxiosError) => Promise.reject(error.response));
};
